module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/cb64c5d445f740053b5079d9331e2607.png";